import { render, staticRenderFns } from "./UpdateBranch.vue?vue&type=template&id=567b0d1f&scoped=true&"
import script from "./UpdateBranch.vue?vue&type=script&lang=js&"
export * from "./UpdateBranch.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBranch.vue?vue&type=style&index=0&id=567b0d1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b0d1f",
  null
  
)

export default component.exports